module.exports = __webpack_public_path__ + "../resources/img/ic_us_battery_left 1.3ffdd0c9.svg";